/**
 * 个位数补零
 * @param value
 */
export const getDoubleDigit = (value: number | string): string => {
    const valueStr = typeof value === 'string' ? value : value.toString();
    return valueStr.length === 1 ? `0${valueStr}` : valueStr;
};
